import {
  Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2, ViewChild, AfterViewInit,
  TemplateRef, HostListener
} from '@angular/core';
import {
  IGridOptions, IColumns, IExportExcel, ISearchPanel, IScroll, Toolbar, IColumnHiding,
  ICheckbox, IEditing, IColumnchooser, IDetail, Color
} from '../../interfaces';
import { DxDataGridComponent } from 'devextreme-angular';
import { MatDialog } from '@angular/material/dialog';
import { isEmpty } from 'lodash';

import { locale, loadMessages, formatMessage } from 'devextreme/localization';

import deMessages from "devextreme/localization/messages/es.json";

import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';
export class SimpleObject {
  value: number | string;
  name: string;
  icon?: string;
  badge?: string;
}

@Component({
  selector: 'app-grid-component',
  templateUrl: './grid-component.component.html',
  styleUrls: ['./grid-component.component.scss']
})
export class GridComponentComponent implements OnInit, AfterViewInit {

  @ViewChild('Gridlightbox') Gridlightbox: TemplateRef<any>;
  @ViewChild('grid') dataGrid: DxDataGridComponent;
  @ViewChild('griddetail') dataGriddetail: DxDataGridComponent;
  @ViewChild('grid', { read: ElementRef }) grid: ElementRef;
  @ViewChild('griddetail', { read: ElementRef }) griddetail: ElementRef;
  // ******************SE RECIBEN PARAMETROS Y SE ENVIA RESPUESTA**************** */
  @Input() nombreReporte: string;
  @Input() datos: any[];
  @Input() datosdetail: [];
  @Input() Detail: IDetail;
  @Input() gridOptions: IGridOptions;
  @Input() columnHiding: IColumnHiding;
  @Input() Checkbox: ICheckbox;
  @Input() Editing: IEditing;
  @Input() CheckboxDetail: ICheckbox;
  @Input() Columnchooser: IColumnchooser;
  @Input() columns: IColumns[];
  @Input() columnsdetail: IColumns[];
  @Input() exportExcel: IExportExcel;
  @Input() searchPanel: ISearchPanel;
  @Input() scroll: IScroll;
  @Input() toolbar: Toolbar[];
  @Input() toolbardetail: Toolbar[];
  @Input() Color: Color;
  @Input() keyfather: string;
  @Input() keyfilter: string;
  @Input() keyDetalle: string;
  @Input() reglas: boolean;
  @Input() selectedRowKeys: any[];
  @Input() selectedRowKeysDetail: any[];
  @Input() KeyExprDetail: string;
  @Input() id: string;
  @Input() descargarExcel:Boolean;
  @Input() totalRegistros:number = 0;

  @Output() messageEvent = new EventEmitter<{ event: string, data: [] }>();
  remoteOperations: boolean;
  @Output() datosevent = new EventEmitter<{ data: [], event: any }>();
  @Output() datosdetailevent = new EventEmitter<{ data: [], event: any, datosPadre: any }>();
  @Output() editevent = new EventEmitter<any>();
  @Output() onInitialized = new EventEmitter<any>();
  @Output() onRowUpdated = new EventEmitter<any>();
  @Output() onRowInserted = new EventEmitter<any>();
  @Output() onRowRemoved = new EventEmitter<any>();
  @Output() onInitNewRow = new EventEmitter<any>();
  @Output() modificar = new EventEmitter<{ modificar }>();
  @Output() eliminar = new EventEmitter<{ eliminar }>();
  @Output() archivarCfdi = new EventEmitter<{ archivarCfdi }>();
  @Output() cancelarCfdi = new EventEmitter<{ cancelarCfdi }>();
  @Output() estatusCFDI = new EventEmitter<{ estatusCFDI }>();
  @Output() descargaPDF = new EventEmitter<{ descargaPDF }>();
  @Output() descargaXML = new EventEmitter<{ descargaXML }>();
  @Output() sendEmail = new EventEmitter<{ sendEmail }>();
  @Output() duplicarCFDI = new EventEmitter<{ duplicarCFDI }>();


  public contador = 0;
  public contadordetail = 0;
  public toole;
  public tooledetail;
  documentos: [];
  DataSourceStorage: any;
  public newInnerWidth: number;
  justDeselected: any;

  formatMessage = formatMessage;
  downloadsBorrador: { value: number; name: string; icon: string; }[];
  downloadsTimbrada: { value: number; name: string; icon: string; }[];
  downloadsCancelada: { value: number; name: string; icon: string; }[];
  datosExcel: any[];

  constructor(private element: ElementRef, private renderer: Renderer2, public dialog: MatDialog) {
    this.DataSourceStorage = [];
    loadMessages(deMessages);
    locale('es');
  }

  ngAfterViewInit() {
    const div = this.grid.nativeElement.querySelector('.dx-datagrid-filter-panel');
    const parent = this.grid.nativeElement.querySelector('.dx-datagrid');
    const refChild = this.element.nativeElement.querySelector('.dx-datagrid-headers');
    if (div && parent && refChild) {
      this.renderer.insertBefore(parent, div, refChild);
    }
  }

  // ******************PARAMETROS QUE SE AJUSTARAN SEGUN SE REAJUSTE LA RESOLUCION DEL DISPOSITIVO**************** */
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.newInnerWidth = event.target.innerWidth;
    if (this.newInnerWidth <= 768 ) {
      this.columnHiding = { hide: true };
      this.gridOptions = { paginacion: 10, pageSize: [10, 30, 50, 100] };
    } else if (this.newInnerWidth > 768) {
      this.columnHiding = { hide: false };
      if (this.gridOptions === undefined) {
        this.gridOptions = { paginacion: 100, pageSize: [100, 300, 500] };
      }
    }
  }

  ngOnInit() {
    console.log(this.searchPanel)

    this.datosExcel = this.datos;
    // console.log(this.datos);
    this.datos.forEach((data: any, index) => {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const element = data[key];
          if (key === this.keyDetalle) {
            this.datos[index].detalle = element;
            delete data[key];
          }
        }
      }
    });
    this.newInnerWidth = window.innerWidth;
    if (this.newInnerWidth <= 768 ) {
      this.columnHiding = { hide: true };
      this.gridOptions = { paginacion: 10, pageSize: [10, 30, 50, 100] };
    } else if (this.newInnerWidth > 768) {
      this.columnHiding = { hide: false };
      if (this.gridOptions === undefined ) {
        this.gridOptions = { paginacion: 100, pageSize: [100, 300, 500] };
      }
    }
    const idDocumentos = [];
    this.documentos = [];

    // ******************PARAMETROS DE EXPORTACION**************** */
    this.exportExcel = {  };

    // ******************PARAMETROS DE PARA SELECCION DE COLUMNAS**************** */
    this.Columnchooser = { columnchooser: true };

    // ******************PARAMETROS DE SEARCH**************** */
    // this.searchPanel = { visible: true, width: 250, placeholder: 'Buscar...', filterRow: true };

    // ******************PARAMETROS DE SCROLL**************** */
    this.scroll = { mode: 'standard' };

    // ******************PARAMETROS DE MAESTRO DETALLE**************** */
    if (this.Detail === undefined) {
      this.Detail = { detail: false };
    }

    // ******************PARAMETROS DE CONTROL DE COLORES**************** */
    if (this.Color === undefined) {
      this.Color = { filas: true, columnas: true, alternar: false };
    } else if (this.Color.color === 'gris') {
      this.Color = { filas: false, columnas: false, alternar: true, color: 'gris' };
    } else {
      this.Color = { filas: true, columnas: true, alternar: false };
    }



    // this.downloads = [
    //   'Vista Previa',
    //   'PDF',
    //   'XML',
    //   'Enviar por correo',
    //   'Cancelar',
    //   'Archivar'
    // ];

    // this.downloads = [
    //   { value: 1, name: 'Vista Previa', icon: 'file' },
    //   { value: 2, name: 'PDF', icon: 'pdffile' },
    //   { value: 3, name: 'XML', icon: 'variable' },
    //   { value: 4, name: 'Enviar por correo', icon: 'email' },
    //   { value: 5, name: 'Cancelar', icon: 'close' },
    //   { value: 6, name: 'Archivar', icon: 'inactivefolder' }
    // ]

    this.downloadsBorrador = [
      { value: 1, name: 'Editar', icon: 'file' },
      { value: 6, name: 'Eliminar', icon: 'trash' },
      { value: 2, name: 'PDF', icon: 'pdffile' },
      // { value: 8, name: 'Estatus', icon: 'bookmark' },
    ]

    this.downloadsTimbrada = [
      // { value: 1, name: 'Vista Previa', icon: 'file' },
      { value: 2, name: 'PDF', icon: 'pdffile' },
      { value: 3, name: 'XML', icon: 'variable' },
      { value: 4, name: 'Enviar por correo', icon: 'email' },
      { value: 5, name: 'Cancelar', icon: 'close' },
      { value: 8, name: 'Duplicar', icon: 'copy' }
      // { value: 8, name: 'Estatus', icon: 'bookmark' },
    ]

    this.downloadsCancelada = [
      // { value: 1, name: 'Vista Previa', icon: 'file' },
      { value: 2, name: 'PDF', icon: 'pdffile' },
      { value: 3, name: 'XML', icon: 'variable' },
      { value: 4, name: 'Enviar por correo', icon: 'email' },
      { value: 7, name: 'Acuse de cancelación', icon: 'pdffile' },
      // { value: 8, name: 'Estatus', icon: 'bookmark' },
    ]
  }

  // ******************SE DEVUELVE EVENTO CLICK**************** */
  onclick(event, data) {
    this.messageEvent.emit({ event, data });
  }

  // ******************CONTADOR DE ITEMS SELECCINADOS Y DEVUELVE DATOS AL EMITER**************** */

  downloads: SimpleObject[];

  onButtonClick( e ){
    console.log( e );
  }

  onItemClick($event, data){
    const evento = $event.itemData.value;
    console.log("onItemClick", evento);
    console.log(data.data);
    switch (evento) {
      case 1:
        this.Modificar(data);
        break;
      case 2:
        this.descargaPDFfn( data );
        break;
      case 3:
        this.descargaXMLfn( data );
        break;
      case 4:
        this.sendEmailfn( data );
        break;
      case 5:
        this.cancelarCfdiFn(data);
        break;
      case 6:
        this.archivarCfdiFn(data);
        break;
      case 7:
        this.estatusCFDIFn(data);
        break;
      case 8:
        this.duplicarCFDIFn(data);
        break;
    }
  }

  onSelectionChanged(e) {
    if (this.reglas) {
      e.component.collapseAll(-1);
      e.component.expandRow(e.currentSelectedRowKeys[0]);
    }
    const disabledKeys = e.currentSelectedRowKeys.filter(i => (i.disable));
    if (disabledKeys.length > 0) {
      if (this.justDeselected) {
        this.justDeselected = false;
        e.component.deselectAll();
      } else {
        this.justDeselected = true;
        e.component.deselectRows(disabledKeys);
      }
    }
    const data = e.selectedRowsData;
    this.datosevent.emit({ data, event: e });
    const cont = [];
    cont.push(e.selectedRowKeys);
    this.contador = cont[0].length;
    for (let i = 0; i < this.toole.toolbarOptions.items.length - 1; i++) {
      // if (this.toole.toolbarOptions.items[i].factura) {
      //   if (this.toole.toolbarOptions.items[i].factura === 'factura') {
      //     if (cont[0].length >= 1) {
      //       this.toole.toolbarOptions.items[i].visible = true;
      //       this.toole.toolbarOptions.items[i].name = '';
      //     }
      //     if (cont[0].length <= 0) {
      //       this.toole.toolbarOptions.items[i].visible = false;
      //       this.toole.toolbarOptions.items[i].name = '';
      //     }
      //   }
      //   this.toole.toolbarOptions.items[i].name = '';
      // } else {
        if (this.toole.toolbarOptions.items[i].name) {
          if (cont[0].length >= 1 && this.toole.toolbarOptions.items[i].name === 'simple') {
            this.toole.toolbarOptions.items[i].visible = true;
            if (cont[0].length >= 2 && this.toole.toolbarOptions.items[i].name2 === 'multiple') {
              this.toole.toolbarOptions.items[i].visible = false;
            }
          } else if (cont[0].length <= 0 && this.toole.toolbarOptions.items[i].name === 'simple') {
            this.toole.toolbarOptions.items[i].visible = false;
          }
        }
      // }
    }
    this.dataGrid.instance.refresh();
  }

  Modificar(value) {
    this.modificar.emit({ modificar: value });
  }

  archivarCfdiFn = value => {
    this.archivarCfdi.emit({ archivarCfdi: value });
  };

  cancelarCfdiFn = value => {
    this.cancelarCfdi.emit({ cancelarCfdi: value });
  };

  estatusCFDIFn = value => {
    this.estatusCFDI.emit({ estatusCFDI: value });
  };

  Eliminar(value) {
    this.eliminar.emit({ eliminar: value });
  }

  descargaPDFfn( value ){
    this.descargaPDF.emit({ descargaPDF: value });
  }

  descargaXMLfn( value ){
    this.descargaXML.emit({ descargaXML: value });
  }

  sendEmailfn( value ){
    this.sendEmail.emit({ sendEmail: value });
  }

  duplicarCFDIFn(value){
    this.duplicarCFDI.emit({ duplicarCFDI: value });
  }
  // export grid
  exportGrids(e) {
    const context = this;
    const workbook = new ExcelJS.Workbook();
    const general = workbook.addWorksheet('General');
    // const detalles = workbook.addWorksheet('Detalles');
    function setAlternatingRowsBackground(gridCell, excelCell) {
      if (gridCell.rowType === 'header' || gridCell.rowType === 'data') {
        // if (excelCell.fullAddress.row % 2 === 0) {
        //   excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D3D3D3' }, bgColor: { argb: 'D3D3D3' } };
        // }
      }
    }
  exportDataGrid({
    worksheet: general,
    component: context.dataGrid.instance,
    // topLeftCell: { row: 0, column: 0 },
    customizeCell: ({ gridCell, excelCell }) => {
      setAlternatingRowsBackground(gridCell, excelCell)
    }
  })
    .then(() => {
      let columnas = [];
      let datosGrid = [];
      this.columns.forEach(e => {
        columnas.push(e.caption);
      })
      // let headerRow = detalles.addRow(columnas);
      // headerRow.eachCell((cell, number) => {
      //   // cell.fill = {
      //   //   type: 'pattern',
      //   //   pattern: 'solid',
      //   //   fgColor: { argb: 'D3D3D3' },
      //   //   bgColor: { argb: 'FF0000FF' }
      //   // };
      //   cell.font = {
      //     size: 11,
      //     bold: true
      //   }

      // });


      for (let i = 0; i < this.datos.length; i++) {
        // for (let j = 0; j < this.datos[i].detalle.length; j++) {
        //   datosGrid.push(this.datos[i].detalle[j]);
        // }
      }
      // if (this.nombreReporte === 'Roll - Out') {
      //   datosGrid.forEach(x => {
      //     delete x.variabilidad;
      //   });
      // }

      for (let x1 of datosGrid) {
        let i = 1;
        i++;
        let x2 = Object.keys(x1);
        let temp = []
        for (let y of x2) {
          temp.push(x1[y])
        }
        // detalles.addRow(temp);
      }
    })
    .then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.nombreReporte + '-' + new Date().valueOf() + '.xlsx');
      });
    });
}
  // ******************CONTADOR DE ITEMS SELECCINADOS Y DEVUELVE DATOS AL EMITER DE MAESTRO DETALLE**************** */
  onSelectionChangedDetail(e, datosPadre) {
    const disabledKeys = e.currentSelectedRowKeys.filter(i => (i.disable));
    if (disabledKeys.length > 0) {
      if (this.justDeselected) {
        this.justDeselected = false;
        e.component.deselectAll();
      } else {
        this.justDeselected = true;
        e.component.deselectRows(disabledKeys);
      }
    }
    const data = e.selectedRowsData;
    this.datosdetailevent.emit({ data, event: e, datosPadre });
    const dataGrid = e.component;
    const element = e.component._$element;
    const contadorHTML: Element = element[0];
    contadorHTML.getElementsByClassName('countcount')[0].innerHTML = dataGrid.getSelectedRowKeys().length;

    for (let i = 0; i < this.tooledetail.toolbarOptions.items.length - 1; i++) {
      if (this.tooledetail.toolbarOptions.items[i].name) {
        if (dataGrid.getSelectedRowKeys().length >= 1 && this.tooledetail.toolbarOptions.items[i].name === 'simple') {
          this.tooledetail.toolbarOptions.items[i].visible = true;

          if (dataGrid.getSelectedRowKeys().length >= 2 && this.tooledetail.toolbarOptions.items[i].name2 === 'multiple') {
            this.tooledetail.toolbarOptions.items[i].visible = false;

          }
        } else if (dataGrid.getSelectedRowKeys().length <= 0 && this.tooledetail.toolbarOptions.items[i].name === 'simple') {
          this.tooledetail.toolbarOptions.items[i].visible = false;
        }
      }
    }
    this.dataGriddetail.instance.refresh();
  }

  // ******************DEVUELVE LOS DATOS EDITADOS DEL GRID **************** */
  onRowUpdating(e) {
    const key = e.oldData;
    const newdata = e.newData;
    const editdata = {
      key,
      newData: newdata
    };
    this.editevent.emit({ editdata });
    this.dataGrid.instance.repaint();
  }

  // ******************DEVUELVE LOS DATOS EDITADOS DEL GRID MAESTRO DETALLE**************** */
  onRowUpdatingDetail(e) {
    const key = e.oldData;
    const newdata = e.newData;
    const editdata = {
      key,
      newData: newdata
    };
    this.editevent.emit({ editdata });
    this.dataGriddetail.instance.repaint();
  }

  // ******************CREACION DE TOOLBAR**************** */

  onToolbarPreparing(e) {
    this.toole = e;
    // //;
    if(this.Checkbox.checkboxmode == 'multiple'){
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: 'Totalderegistros'
      },
        {
          location: 'before',
          template: 'Contarseleccionados',
          visible: true,
          name: 'simple'
        },
        ...this.toolbar
      );
    }else if (this.descargarExcel) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'Totalderegistros'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: '../../../assets/icons/excel.png',
            onClick: this.exportGrids.bind(this),
            class: "send",
            widht: 300,
            //text: "Exportar Excel"

          }
        },
        {
          location: 'before',
          template: 'Contarseleccionados',
          visible: false,
          name: 'simple'
        },
        ...this.toolbar
      );
    }else{
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: 'Totalderegistros'
      },
        {
          location: 'before',
          template: 'Contarseleccionados',
          visible: false,
          name: 'simple'
        },
        ...this.toolbar
      );

    }
    //console.log(" e.toolbarOptions.items", e.toolbarOptions.items)
  }

  // ******************CREACION DE TOOLBAR MAESTRO DETALLE**************** */

  onToolbarPreparingDetail(e) {
    this.tooledetail = e;

    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'Totalderegistrosdetail'
    },
      {
        location: 'before',
        template: 'Contarseleccionadosdetail'
      },
      ...this.toolbardetail
    );
  }

  // ***************COLUMN CHOOSER EVENT****************** */
  onContentReady(e) {
    if (this.reglas) {
      if (!e.component.getSelectedRowKeys().length) {
        e.component.selectRowsByIndexes(0);
      }
    }
    this.datos.forEach((data: any, index) => {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const element = data[key];
          if (key === this.keyDetalle) {
            this.datos[index].detalle = element;
            delete data[key];
          }
        }
      }
    });
    if (this.Color.color === 'gris') {
      const cont = this.grid.nativeElement.querySelector('.dx-header-row');
      this.renderer.setStyle(cont, 'background', 'transparent');
      this.renderer.setStyle(cont, 'font-weight', 'bold');
    }
  }

  // ***************COLUMN CHOOSER EVENT MAESTRO DETALLE****************** */
  onContentReadyDetail(e) {
    if (this.Color.color === 'gris') {
      const cont = this.griddetail.nativeElement.querySelector('.dx-header-row');
      this.renderer.setStyle(cont, 'background', 'transparent');
      this.renderer.setStyle(cont, 'font-weight', 'bold');
    }
  }
  handlePageChange(e: any) {
    console.log("cambio")
    // const pageNumber = e.pageIndex;
    // const pageSize = e.pageSize;
    // this.loadData(pageNumber, pageSize);
  }
  onInitializedMaster($event) {
    this.onInitialized.emit(this.dataGrid);
    $event.component.selectRows(this.datos[0]);
  }

  onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.command === 'select' && e.data.disable === true) {
      e.cellElement.find('.dx-select-checkbox').dxCheckBox('instance').option('disabled', true);
      e.cellElement.off();
    }
  }

  onCellPreparedDetail(e) {
    if (e.rowType === 'data' && e.column.command === 'select' && e.data.disable === true) {
      e.cellElement.find('.dx-select-checkbox').dxCheckBox('instance').option('disabled', true);
      e.cellElement.off();
    }
  }

  onRowPrepared(e) {
    if (e.rowType === 'data') {
      if (e.data.backgroundcolor) {
        e.rowElement.find('td').css('background', e.data.backgroundcolor);
      }
    }
  }

  dinamicItems( e, o ){
    // console.log("dinamicOptions - o", o.key.idEstatusFactura);
    switch (o.key.idEstatusFactura) {
      case 1:
        this.downloadsBorrador = [
          { value: 1, name: 'Editar', icon: 'file' },
          { value: 5, name: 'Cancelar', icon: 'close' },
          { value: 6, name: 'Archivar', icon: 'inactivefolder' }
        ]
        break;
      case 2:
        this.downloadsTimbrada = [
          { value: 1, name: 'Vista Previa', icon: 'file' },
          { value: 2, name: 'PDF', icon: 'pdffile' },
          { value: 3, name: 'XML', icon: 'variable' },
          { value: 4, name: 'Enviar por correo', icon: 'email' },
          { value: 5, name: 'Cancelar', icon: 'close' },
        ]
        break;
      case 3:
        this.downloadsCancelada = [
          { value: 1, name: 'Vista Previa', icon: 'file' },
          { value: 2, name: 'PDF', icon: 'pdffile' },
          { value: 3, name: 'XML', icon: 'variable' },
          { value: 4, name: 'Enviar por correo', icon: 'email' },
          { value: 7, name: 'Acuse de cancelacion', icon: 'pdffile' }
        ]
        break;
    }


    return this.downloads;
  }

  onRowPreparedDetail(e) {
    if (e.rowType === 'data') {
      if (e.data.backgroundcolor) {
        e.rowElement.find('td').css('background', e.data.backgroundcolor);
      }
    }
  }

  OnRowUpdated($event) {
    this.onRowUpdated.emit($event);
  }

  OnRowInserted($event) {
    this.onRowInserted.emit($event);
  }
  OnRowRemoved($event) {
    this.onRowRemoved.emit($event);
  }
  OnInitNewRow($event) {
    this.onInitNewRow.emit($event);
  }


}
